module.exports = __webpack_public_path__ + "img/fingerprint.eeff6b99.svg";